var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgIconEolNotice = function SvgIconEolNotice(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.629,
    height: 37.409,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .line-eol {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 2px;\n        stroke-linejoin: round;\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-eol-notice",
    transform: "translate(-13.469 1.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "line-eol",
    d: "M516.6,844.186v-7.708h7.2",
    transform: "translate(-483.057 -810.439)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    className: "line-eol",
    x2: 17.846,
    transform: "translate(18.455 5)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    className: "line-eol",
    x2: 13.597,
    transform: "translate(18.605 9.365)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    className: "line-eol",
    x2: 13.597,
    transform: "translate(18.605 14.076)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    className: "line-eol",
    x2: 9.78,
    y2: 9.78,
    transform: "translate(20.606 19.185)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    className: "line-eol",
    x1: 9.78,
    y2: 9.78,
    transform: "translate(20.606 19.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "line-eol",
    d: "M2.685,2.456V37.865H22l7.313-7.313V2.456Z",
    transform: "translate(11.784 -3.101)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEolNotice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-eol-notice.eaf360f6.svg";
export { ForwardRef as ReactComponent };